module.exports = __webpack_public_path__ + "assets/img/Dark.6d307644.svg";